import http from '@/utils/http';

export const searchSpell = (parameter) => {
  return http.request({
    url: '/v1/games/spell/search',
    method: 'post',
    data: parameter
  })
}